// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__PBxxw","cols2":"Grid_cols2__YXpSo"};